import { createFileRoute, Outlet } from "@tanstack/react-router"

import { AppShell } from "../components/layout/app-shell"

function RunDetailLayout() {
  const { slug } = Route.useParams()
  return (
    <AppShell title={`Run ${slug}`} fullWidth fillViewport hideTitle>
      <Outlet />
    </AppShell>
  )
}

export const Route = createFileRoute("/runs/$slug")({
  component: RunDetailLayout,
})
